import styled from 'styled-components/macro'
import { theme, ifProp } from 'styled-tools'
import { color, rgba } from '../../../utils/styles'

const Label = styled.label`
  font-size: 1em;
  font-weight: ${theme('fontWeights.regular')};
  color: ${ifProp('error', color('error'), rgba('base', 0.4))};
`

export default Label
